import React from 'react'
import { useTranslation } from 'react-i18next'

import './NoCover.scss'

function NoCover() {
    const { t } = useTranslation()

    return (
        <div className="no-cover">
            <div className="icon" />
            <div className="text">
                {t('This test does not have a cover. You can view and test the project in the "Preview" tab.')}
            </div>
        </div>
    )
}

export default NoCover
